import { shipmentService } from '@/services';

export const shipmentModule = {
  namespaced: true,
  state: () => ({
    list:{
      data: null,
      error: null,
    },
    listFilters: {},
    shipment:{
      data: null,
      error: null,
    },
    shipmentsExcel:{
      data: null,
      error: null,
    },
    shipmentResource:{
      data: {
        images: null,
        documents: null,
      },
      error: null
    },
  }),
  mutations: {
    loadResource(state, shipmentId) {
      shipmentService.getResources(shipmentId)
        .then((res) => {
          state.shipmentResource.data = { ...res }
        })
        .catch((error) => {
          state.shipmentResource.data.images = null
          state.shipmentResource.data.documents = null
          state.shipmentResource.error = error
        });      
    },
    appendImage(state, entity) {
      state.shipmentResource.data.images.push(entity)
    },
    appendDocument(state, entity) {
      state.shipmentResource.data.documents.push(entity)
    },
    removeImage(state, entity) {
      const currentImages = [ ...state.shipmentResource.data.images ]
      state.shipmentResource.data.images = currentImages.filter(image => image['name'] != entity['name'])
    },
    removeDocument(state, entity) {
      const currentDocuments = [ ...state.shipmentResource.data.documents ]
      state.shipmentResource.data.documents = [ ...currentDocuments.filter(document => document['name'] != entity['name']) ]
    },
    downloadResource(state,request){
      shipmentService.downloadResource(request.shipmentId, request.fileName)
      .then((excel) => {
        state.shipmentResource.data = excel
        state.shipmentResource.error = null
      })
      .catch((error) => {
        state.shipmentResource.data = null
        state.shipmentResource.error = error
      });
    },
    resetResources(state) {
      state.shipmentResource.data.images = null
      state.shipmentResource.data.documents = null
      state.shipmentResource.error = null     
    },
    load(state,request) {
      state.listFilters = { ...JSON.parse(JSON.stringify(request)) }
      shipmentService.getShipments(request.pagination,request.filters)
        .then((res) => {
          state.list.data = res
        })
        .catch((error) => {
          state.list.data = null
          state.list.error = error
        });      
    },
    getById(state, id) {
      shipmentService.getShipmentById(id)
        .then((res) => {
          state.shipment.data = res
        })
        .catch((error) => {
          state.shipment.data = null
          state.shipment.error = error
        });      
    },
    shipmentsExcel(state,request){
      shipmentService.getShipmentsAsExcel(request.filters, request.language)
      .then((excel) => {
        state.shipmentsExcel.data = excel
        state.shipmentsExcel.error = null
      })
      .catch((error) => {
        state.shipmentsExcel.data = null
        state.shipmentsExcel.error = error
      });
    }
  }
}